<template>
	<div class="mt-3 py-5">
		<b-container>

			<div class="content mb-auto">
				<div class="container-fluid sp-form-container">

					<!--Main layout-->
					<div class="container pl-3 pr-3">

            <div class="row">

              <div class="col-md-3 sidebar rounded">

                  <div class="card my-3">
                      <div class="card-body text-center text-muted">

                          <div class="row">
                              <div class="col-md-12">

                                  <div class="col-sm-12 control-label text-left p-0"><span>カテゴリ</span></div>
                                  <div class="row">
                                    <div class="col-md-12 px-2 pt-0">
                                        <div class="main_search_type top_modal row p-3 mb-5">
                                            <input type="radio" id="select1" value="1" v-model="main_search_type" @click="reset(1)">
                                            <label class="col-6" for="select1">ピアノ</label>
                                            <input type="radio" id="select2" value="2" v-model="main_search_type" @click="reset(2)">
                                            <label class="col-6" for="select2">販売者</label>
                                        </div>
                                    </div>
                                  </div>

                                  <template v-if="String(main_search_type) == '2'">

                                    <div class="col-sm-12 control-label text-left p-0"><span>フリーワード</span></div>
                                    <div class="row">
                                      <div class="col-md-12 px-2 pt-0">
                                          <input type="text" placeholder="" v-model="search_word" class="form-control" style="padding: .25rem!important">
                                      </div>
                                    </div>

                                    <div class="sort_disp col-sm-12 mt-3 control-label text-left p-0"><span>並び替え</span></div>
                                    <div class="sort_disp row">
                                      <div class="col-md-12 px-2 pt-0">
                                          <select class="form-control" v-model="search_sort_type">
                                            <option v-for="(item, index) in sort_type_seller" :value="item.no" :key="`sort_type-${item.no}`">{{ item.name }}</option>
                                          </select>
                                      </div>
                                    </div>

                                    <div class="sp_menu">
                                        <div class="row">
                                          <div class="col-12 pr-0 pl-2 pt-0">
                                            <h6 class="sp_menu_open font-weight-bold p-0 m-0 mt-3" @click="sp_open">{{ sp_open_text }}</h6>
                                          </div>
                                        </div>
                                    </div>
                                    <div class="menu_contents" v-show="is_sp_open">

                                        <h6 class="font-weight-bold p-0 m-0 mt-3">エリアからしぼる</h6>
                                        <div class="col-sm-12 mt-3 control-label text-left p-0"><span>都道府県</span></div>
                                        <div class="row">
                                          <div class="col-md-12 px-2 pt-0">
                                            <select class="form-control" v-model="search_region" @change="set_city('')">
                                              <option v-for="(item, index) in search_region_arr" :value="item.no" :key="`search_region-${item.no}`">{{ item.name }}</option>
                                            </select>
                                          </div>
                                        </div>

                                        <template v-if="search_region != ''">
                                          <div class="col-sm-12 mt-3 control-label text-left p-0"><span>市区町村</span></div>
                                          <div class="row">
                                            <div class="col-md-12 px-2 pt-0">
                                              <select class="form-control" v-model="search_city">
                                                <option v-for="(item, index) in search_city_arr" :value="item.no" :key="`search_city-${item.no}`">{{ item.name }}</option>
                                              </select>
                                            </div>
                                          </div>
                                        </template>

                                        <h6 class="font-weight-bold p-0 m-0 my-3">その他条件からしぼる</h6>
                                        <!--<label for="search[federation_registration][]" class="col-sm-12 control-label">連盟登録の有無  <span class="required_mark">必須</span><div class="mt-2">※加入している連盟にチェックしてください。<br>掲載している連盟に加入していない場合は「独立系（連盟無所属）」にチェックを入れてください。</div></label>-->
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="search_about_areas_sell" class="mr-2">全国通販可能
                                        </label>
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="search_whether_pay_installments" class="mr-2">分割払い可
                                        </label>
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="search_credit_payment" class="mr-2">クレジットカード可
                                        </label>
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="search_about_test_bullet" class="mr-2">試弾可能
                                        </label>
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="search_test_bullet_required" class="mr-2">試弾必須
                                        </label>
                                        <!--
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="" class="mr-2">保証あり
                                        </label>
                                        -->
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="search_about_return" class="mr-2">返品可能
                                        </label>
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="search_about_exchange" class="mr-2">交換可能
                                        </label>
                                    </div>

                                  </template>

                                  <template v-if="String(main_search_type) == '1'">

                                    <div class="col-sm-12 control-label text-left p-0"><span>フリーワード</span></div>
                                    <div class="row">
                                      <div class="col-md-12 px-2 pt-0">
                                          <input type="text" placeholder="" v-model="search_word" class="form-control" style="padding: .25rem!important">
                                      </div>
                                    </div>

                                    <div class="sort_disp col-sm-12 mt-3 control-label text-left p-0"><span>並び替え</span></div>
                                    <div class="sort_disp row">
                                      <div class="col-md-12 px-2 pt-0">
                                          <select class="form-control" v-model="search_sort_type">
                                            <option v-for="(item, index) in sort_type_product" :value="item.no" :key="`sort_type-${item.no}`">{{ item.name }}</option>
                                          </select>
                                      </div>
                                    </div>

                                    <div class="sp_menu">
                                        <div class="row">
                                          <div class="col-12 pr-0 pl-2 pt-0">
                                            <h6 class="sp_menu_open font-weight-bold p-0 m-0 mt-3" @click="sp_open">{{ sp_open_text }}</h6>
                                          </div>
                                        </div>
                                    </div>
                                    <div class="menu_contents" v-show="is_sp_open">

                                        <h6 class="font-weight-bold p-0 m-0 mt-3">エリアからしぼる</h6>
                                        <div class="col-sm-12 mt-3 control-label text-left p-0"><span>都道府県</span></div>
                                        <div class="row">
                                          <div class="col-md-12 px-2 pt-0">
                                            <select class="form-control" v-model="search_region" @change="set_city('')">
                                              <option v-for="(item, index) in search_region_arr" :value="item.no" :key="`search_region-${item.no}`">{{ item.name }}</option>
                                            </select>
                                          </div>
                                        </div>

                                        <template v-if="search_region != ''">
                                        <div class="col-sm-12 mt-3 control-label text-left p-0"><span>市区町村</span></div>
                                        <div class="row">
                                          <div class="col-md-12 px-2 pt-0">
                                            <select class="form-control" v-model="search_city">
                                              <option v-for="(item, index) in search_city_arr" :value="item.no" :key="`search_city-${item.no}`">{{ item.name }}</option>
                                            </select>
                                          </div>
                                        </div>
                                        </template>

                                        <h6 class="font-weight-bold p-0 m-0 my-3">状態からしぼる</h6>
                                        <div class="row">
                                          <div class="col-md-12 px-2 pt-0">
                                            <select class="form-control" v-model="search_state">
                                              <option v-for="(item, index) in state" :value="item.no" :key="`state-${item.no}`">{{ item.name }}</option>
                                            </select>
                                          </div>
                                        </div>

                                        <h6 class="font-weight-bold p-0 m-0 my-3">タイプからしぼる</h6>
                                        <div class="row">
                                          <div class="col-md-12 px-2 pt-0">
                                            <select class="form-control" v-model="search_type">
                                              <option v-for="(item, index) in type" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                            </select>
                                          </div>
                                        </div>

                                        <h6 class="font-weight-bold p-0 m-0 my-3">ブランドからしぼる</h6>
                                        <div class="row">
                                          <div class="col-md-12 px-2 pt-0">
                                            <select class="form-control" v-model="search_brand" multiple>
                                              <option v-for="(item, index) in brand" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
                                            </select>
                                          </div>
                                        </div>

                                        <h6 class="cost_disp font-weight-bold p-0 m-0 my-3">商品価格からしぼる</h6>
                                        <div class="cost_disp row">
                                          <div class="col-5 pr-0 pl-2 pt-0">
                                              <input type="tel" placeholder="" v-model="search_price_from" class="form-control" style="padding: .25rem!important">
                                          </div>
                                          <div class="col-2 px-2 pt-0">
                                              <span>～</span>
                                          </div>
                                          <div class="col-5 pl-0 pr-2 pt-0">
                                              <input type="tel" placeholder="" v-model="search_price_to" class="form-control" style="padding: .25rem!important">
                                          </div>
                                        </div>

                                        <h6 class="cost_disp font-weight-bold p-0 m-0 my-3">送料からしぼる</h6>
                                        <div class="cost_disp row">
                                          <div class="col-5 pr-0 pl-2 pt-0">
                                              <input type="tel" placeholder="" v-model="search_send_price_from" class="form-control" style="padding: .25rem!important">
                                          </div>
                                          <div class="col-2 px-2 pt-0">
                                              <span>～</span>
                                          </div>
                                          <div class="col-5 pl-0 pr-2 pt-0">
                                              <input type="tel" placeholder="" v-model="search_send_price_to" class="form-control" style="padding: .25rem!important">
                                          </div>
                                        </div>

                                        <h6 class="font-weight-bold p-0 m-0 my-3">サイズからしぼる</h6>
                                        <div class="row">
                                          <div class="col-md-12 px-2 pt-0">
                                            <select class="form-control" v-model="search_size">
                                              <option v-for="(item, index) in size" :value="item.no" :key="`size-${item.no}`">{{ item.name }}</option>
                                            </select>
                                          </div>
                                        </div>

                                        <h6 class="font-weight-bold p-0 m-0 my-3">機能からしぼる</h6>
                                        <div class="row">
                                          <div class="col-md-12 px-2 pt-0">
                                            <select class="form-control" v-model="search_function">
                                              <option v-for="(item, index) in function_arr" :value="item.no" :key="`function-${item.no}`">{{ item.name }}</option>
                                            </select>
                                          </div>
                                        </div>

                                        <h6 class="font-weight-bold p-0 m-0 my-3">カラーからしぼる</h6>
                                        <div class="row">
                                          <div class="col-md-12 px-2 pt-0">
                                            <select class="form-control" v-model="search_color">
                                              <option v-for="(item, index) in color" :value="item.no" :key="`color-${item.no}`">{{ item.name }}</option>
                                            </select>
                                          </div>
                                        </div>

                                        <h6 class="font-weight-bold p-0 m-0 my-3">年代からしぼる</h6>
                                        <div class="row">
                                          <div class="col-md-12 px-2 pt-0">
                                            <select class="form-control" v-model="search_year">
                                              <option v-for="(item, index) in year" :value="item.no" :key="`year-${item.no}`">{{ item.name }}</option>
                                            </select>
                                          </div>
                                        </div>

                                        <h6 class="font-weight-bold p-0 m-0 my-3">その他条件からしぼる</h6>
                                        <!--<label for="search[federation_registration][]" class="col-sm-12 control-label">連盟登録の有無  <span class="required_mark">必須</span><div class="mt-2">※加入している連盟にチェックしてください。<br>掲載している連盟に加入していない場合は「独立系（連盟無所属）」にチェックを入れてください。</div></label>-->
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="search_about_areas_sell" class="mr-2">全国通販可能
                                        </label>
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="search_whether_pay_installments" class="mr-2">分割払い可
                                        </label>
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="search_credit_payment" class="mr-2">クレジットカード可
                                        </label>
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="search_about_test_bullet" class="mr-2">試弾可能
                                        </label>
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="search_test_bullet_required" class="mr-2">試弾必須
                                        </label>
                                        <!--
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="" class="mr-2">保証あり
                                        </label>
                                        -->
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="search_about_return" class="mr-2">返品可能
                                        </label>
                                        <label class="col-md-12 checkbox-inline p-0 text-left" style="font-size: 0.9rem;">
                                            <input type="checkbox" v-model="search_about_exchange" class="mr-2">交換可能
                                        </label>

                                    </div>

                                  </template>

                              </div>
                          </div>

                          <div class="row text-center mt-3">
                              <div class="col-md-12">
                                  <a href="javascript:void(0);" style="color: #575757;font-size: 1rem;width: 100%;color: #fefefe;background-color: #edbb4b;" class="m-0 p-2 btn search_button" @click="variable_to_param">検索する</a>
                              </div>
                              <div class="col-md-12 mt-2">
                                  <a href="javascript:void(0);" style="color: #575757;font-size: 1rem;width: 100%;border: solid 1px #c5c5c5;" class="m-0 p-2 btn" @click="reset(0)">リセットする</a>
                              </div>
                          </div>


                      </div>
                  </div>

              </div>

              <div class="col-sm-9">

                <!-- パンくず -->

                <!-- メインコンテンツ -->
                <div class=" main search_contents">

                  <template v-if="String(exec_main_search_type) == '1'">

                    <template v-if="allProducts.length==0">
                      <div class="p-2 mt-3">
                          <div style="font-size: 1.1rem;font-weight: bold;color: #878787;text-align: center;">
                            検索結果のピアノはありません。
                          </div>
                          <!--
                          <div class="my-2 search_conditions" style="font-size: 1rem;color: #878787;text-align: center;">
                            検索条件 : <span class="search_condition"></span>
                          </div>
                          <div class="my-2" style="font-size: 1rem;color: #878787;text-align: center;">
                            並び替え条件 : <span class="sort_condition"></span>
                          </div>
                          -->
                      </div>
                    </template>
                    <template v-else-if="allProducts.length>0">
                      <div class="p-2 mt-3">
                          <div style="font-size: 1.1rem;font-weight: bold;color: #878787;text-align: center;">
                            検索結果 : {{ allProducts.length }} 件
                          </div>
                          <!--
                          <div class="my-2 search_conditions" style="font-size: 1rem;color: #878787;text-align: center;">
                            検索条件 : <span class="search_condition"></span>
                          </div>
                          <div class="my-2" style="font-size: 1rem;color: #878787;text-align: center;">
                            並び替え条件 : <span class="sort_condition"></span>
                          </div>
                          -->
                      </div>
                    </template>

                    <div v-for="(product, index) in allGetProducts">
                      <div class="card col-md-12 pl-0 pr-0 m-0 mb-2">
                        <div class="card-body row p-2 m-0">
                          <div class="col-md-5 p-2 m-0" style="display: flex;align-items: center;justify-content: center;">
                            <img class="" :src="product['image1']" style="width: 80%;height: auto;">
                          </div>
                          <div class="card col-md-7 pl-0 pr-0 m-0" style="position: relative;">
                            <div class="card-body">
                              <h5 class="font-weight-bold p-0 m-0 mb-3">{{ product['title'] }}</h5>
                              <p class="card-text mb-3">
                                <span class="">{{ product['strong_point'] }}</span>
                              </p>
                              <p class="card-text mb-3" style="color: red;">価格(税抜):　{{ String(product['price']).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') }}円</p>
                              <p class="card-text m-0 d-flex">販売者:　
                                <span class="mr-2" v-if="product['legal_person']==1">{{ product['corp_name'] }}</span>
                                <span class="mr-2" v-if="product['legal_person']==0">{{ product['store_name'] }}</span>
                                <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="product['evaluation']"></star-rating>
                              </p>
                              <p class="card-text m-0">掲載日:　{{ date_only_format(product['opened_at']) }}</p><!-- YYYY年MM月DD日 -->
                              <p class="card-text m-0">ブランド:　{{ get_hash_value(brand, product['brand']) }}</p>
                              <p class="card-text m-0">型番:　{{ cinit(product['model_number'], "-") }}</p>
                              <p class="card-text m-0">外装:　{{ get_hash_value(color, product['color']) }}／{{ cinit(product['exterior_finish'], "-") }}</p>
                              <p class="card-text m-0">展示（保管）場所:　{{ cinit(product['storage_location'], "-") }}</p>
                              <button @click="jumpDetail(product['id'])" style="position: absolute;bottom: 20px;right: 20px;width: 80px;" class="btn btn-primary">詳細</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="page" v-if="allProducts.length>0">
                      <vuejs-paginate
                        :page-count="allGetPageCountProduct"
                        :page-range="3"
                        :margin-pages="2"
                        :click-handler="allClickCallbackProduct"
                        :prev-text="'＜'"
                        :next-text="'＞'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                      </vuejs-paginate>
                    </div>

                  </template>

                  <template v-else-if="String(exec_main_search_type) == '2'">

                    <template v-if="allSellers.length==0">
                      <div class="p-2 mt-3">
                          <div style="font-size: 1.1rem;font-weight: bold;color: #878787;text-align: center;">
                            検索結果の販売者はありません。
                          </div>
                          <!--
                          <div class="my-2 search_conditions" style="font-size: 1rem;color: #878787;text-align: center;">
                            検索条件 : <span class="search_condition"></span>
                          </div>
                          <div class="my-2" style="font-size: 1rem;color: #878787;text-align: center;">
                            並び替え条件 : <span class="sort_condition"></span>
                          </div>
                          -->
                      </div>
                    </template>
                    <template v-else-if="allSellers.length>0">
                      <div class="p-2 mt-3">
                          <div style="font-size: 1.1rem;font-weight: bold;color: #878787;text-align: center;">
                            検索結果 : {{ allSellers.length }} 件
                          </div>
                          <!--
                          <div class="my-2 search_conditions" style="font-size: 1rem;color: #878787;text-align: center;">
                            検索条件 : <span class="search_condition"></span>
                          </div>
                          <div class="my-2" style="font-size: 1rem;color: #878787;text-align: center;">
                            並び替え条件 : <span class="sort_condition"></span>
                          </div>
                          -->
                      </div>
                    </template>

                    <div v-for="(seller, index) in allGetSellers">
                      <div class="card col-md-12 pl-0 pr-0 m-0 mb-2">
                        <div class="card-body row p-2 m-0">
                          <div class="col-md-5 p-2 m-0" style="display: flex;align-items: center;justify-content: center;">
                            <img class="" :src="seller['image1']" style="width: 80%;height: auto;">
                          </div>
                          <div class="card col-md-7 pl-0 pr-0 m-0" style="position: relative;">
                            <div class="card-body">
                              <div style="position: relative;">
                                <div class="d-flex">
                                  <strong class="mr-2" v-if="seller['legal_person']==1">{{ seller['corp_name'] }}</strong>
                                  <strong class="mr-2" v-if="seller['legal_person']==0">{{ seller['store_name'] }}</strong>
                                  <star-rating v-bind:increment="0.1" v-bind:max-rating="5" inactive-color="#000" active-color="#fffc2f" v-bind:star-size="15" v-model="seller['evaluation']"></star-rating>
                                </div>
                                <p class="card-text mb-3">{{ seller['slogan'] }}</p>
                                <p class="card-text mb-3">ピアノ販売数　{{ seller['sell_num'] }}人</p>
                                <button @click="jumpSellerDetail(seller['id'])" style="position: absolute;bottom: 0px;right: 0px;width: 80px;" class="btn btn-primary">詳細</button>
                              </div>
                              <hr>
                              <div>
                                <p>{{ seller['region'] + ': ' + seller['address_1'] }}</p>
                                <p v-if="seller['whether_pay_installments']==1">ローン返済可能</p>
                                <p v-if="seller['whether_pay_installments']==2">ローン返済不可</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="page" v-if="allSellers.length>0">
                      <vuejs-paginate
                        :page-count="allGetPageCountSeller"
                        :page-range="3"
                        :margin-pages="2"
                        :click-handler="allClickCallbackSeller"
                        :prev-text="'＜'"
                        :next-text="'＞'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                      </vuejs-paginate>
                    </div>

                  </template>

                </div>

              </div>
            </div>

  				</div>

				</div>
			</div>

		</b-container>
	</div>
</template>

<script>
import VueJsPaginate from "vuejs-paginate";
import StarRating from 'vue-star-rating'
import axios from 'axios';
const noretryAuthAxios = axios.create();
noretryAuthAxios.defaults.baseURL = 'https://api.piachu.net/';

export default {
  name: 'Search',
  components: {
    'vuejs-paginate': VueJsPaginate,
    'star-rating': StarRating,
  },
  data () {
		const state = [
      {"no":"0","name":"未選択"},
			{"no":"1","name":"新古品"},
			{"no":"2","name":"中古品（非常に良い）"},
			{"no":"3","name":"中古品（良い）"},
			{"no":"4","name":"中古品（あまり良くない）"},
			{"no":"5","name":"中古品（悪い）"},
		];
		const type = [
      {"no":"0","name":"未選択"},
			{"no":"1","name":"グランドピアノ（GP）"},
			{"no":"2","name":"アップライトピアノ（UP）"},
	    ];
		const brand = [
      // {"no":"0","name":"未選択"},
			{"no":"1","name":"ヤマハ（YAMAHA）"},
			{"no":"2","name":"カワイ（KAWAI）"},
			{"no":"3","name":"スタインウェイ・アンド・サンズ　（Steinway&Sons）"},
			{"no":"4","name":"ベーゼンドルファー　（Bösendorfer）"},
			{"no":"5","name":"ベヒシュタイン　（BECHSTEIN）"},
			{"no":"6","name":"ボストン　（BOSTON）"},
			{"no":"7","name":"ディアパソン　（DIAPASON）"},
			{"no":"8","name":"アポロ　（APOLLO）"},
			{"no":"9","name":"国産ピアノ"},
			{"no":"10","name":"輸入ピアノ"},
	    ];
		const color = [
      {"no":"0","name":"未選択"},
			{"no":"1","name":"黒"},
			{"no":"2","name":"木目"},
			{"no":"3","name":"白"},
			{"no":"4","name":"その他"},
	    ];
		// const sort_type = [
    //   {"no":"0","name":"おすすめ順"},
    //   {"no":"1","name":"新着順"},
    //   {"no":"2","name":"現在販売中の台数順"},
    //   {"no":"3","name":"過去に販売した台数順"},
    //   {"no":"4","name":"レビュー件数順"},
    //   {"no":"5","name":"レビューの高い順"},
    //   {"no":"6","name":"お気に入りの多い順"},
    //   ];
		const sort_type_product = [
      {"no":"0","name":"おすすめ順"},
      {"no":"1","name":"安い順"},
      {"no":"2","name":"高い順"},
      {"no":"3","name":"新着順"},
      {"no":"4","name":"レビュー件数順"},
      {"no":"5","name":"レビューの高い順"},
      {"no":"6","name":"お気に入りの多い順"},
      ];
		const sort_type_seller = [
      {"no":"0","name":"おすすめ順"},
      {"no":"1","name":"新着順"},
      {"no":"2","name":"現在販売中の台数順"},
      {"no":"3","name":"過去に販売した台数順"},
      {"no":"4","name":"レビュー件数順"},
      {"no":"5","name":"レビューの高い順"},
      {"no":"6","name":"お気に入りの多い順"},
      ];
		const size = [
      {"no":"0","name":"未選択"},
      {"no":"1","name":"アップライト：小（高さ　120cm未満）"},
			{"no":"2","name":"アップライト：標準（高さ　121～129cm未満）"},
			{"no":"3","name":"アップライト：大（高さ：130～134cm）"},
			{"no":"4","name":"グランド：（奥行き 150cmほど）"},
			{"no":"5","name":"グランド：（奥行き 161cmほど）"},
			{"no":"6","name":"グランド：（奥行き 173cmほど）"},
			{"no":"7","name":"グランド：（奥行き 186cmほど）"},
			{"no":"8","name":"グランド：（奥行き 200cmほど）"},
			{"no":"9","name":"グランド：（奥行き 212cmほど）"},
			{"no":"10","name":"グランド：（奥行き 227cmほど）"},
			{"no":"11","name":"グランド：セミコンサート・フルコンサートグランド"},
	    ];
		const function_arr = [
      {"no":"0","name":"未選択"},
      {"no":"1","name":"消音"},
			{"no":"2","name":"自動演奏"},
	    ];
		const year = [
      {"no":"0","name":"未選択"},
      {"no":"1","name":"～80年代"},
			{"no":"2","name":"90年代"},
			{"no":"3","name":"2000年以降"},
	    ];

		return {
			state,
			type,
			brand,
			color,
      // sort_type,
      sort_type_product,
      sort_type_seller,
      size,
      function_arr,
      year,

      // 検索
      isSmart: false,
      is_sp_open: false,
      sp_open_text: "＋詳細検索",
      // 共通検索項目
      exec_main_search_type: null,
      main_search_type: 1,
      search_word: "",
      search_sort_type: 0,
      search_region_arr: [
        {"no":"0","name":"未選択"},
      ],
      search_city_arr: [
        {"no":"0","name":"未選択"},
      ],
      address_info: null,

      search_region: "",
      search_city: "",
      search_about_areas_sell: false,
      search_whether_pay_installments: false,
      search_credit_payment: false,
      search_about_test_bullet: false,
      search_test_bullet_required: false,
      search_about_return: false,
      search_about_exchange: false,
      // 以下商品のみ検索項目      
      search_state: 0,
      search_type: 0,
      search_brand: [],
      search_price_from: null,
      search_price_to: null,
      search_send_price_from: null,
      search_send_price_to: null,
      search_size: 0,
      search_function: 0,
      search_color: 0,
      search_year: 0,

			all_products: [],
			all_parPage_product: 5,
			all_currentPage_product: 1,

      all_sellers: [],
			all_parPage_seller: 5,
			all_currentPage_seller: 1,

    }
  },
  methods: {
    handleResize: function() {
      if(window.innerWidth <= 764) {
        this.isSmart = true;
      } else {
        this.isSmart = false;
        this.is_sp_open = true; // PCは表示
      }
    },
    search_exec() {
      // alert(location.search);
      this.get_search();
      return false;
    },
		async get_search() {
			this.$store.dispatch('user/get_search', {
        params: location.search,
      }).then(res => {
				console.log(res);
				this.all_products = res.data.products;
				this.all_sellers = res.data.sellers;
        this.exec_main_search_type = this.main_search_type;
        if ( this.search_region && String(this.search_region) != "" ) {
          if ( this.search_city && String(this.search_city) != "" ) {
            this.set_city(this.search_city);
          } else {
            this.set_city('');
          }
        }
				console.log(this.all_products);
				console.log(this.all_sellers);
				// this.productCount = this.all_products.length;
			}, error => {
				console.log('error発生');
				console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
			});
		},
    reset(main_search_type) {
      if (main_search_type!=0) {
        this.main_search_type = main_search_type
      }
      this.search_word = "";
      this.search_sort_type = 0;
      // this.search_region_arr = [
      //   {"no":"","name":"未選択"},
      // ];
      // this.search_city_arr = [
      //   {"no":"","name":"未選択"},
      // ];
      this.search_region = "";
      this.search_city = "";
      this.set_address_info();
      this.set_city();
      this.search_about_areas_sell = false;
      this.search_whether_pay_installments = false;
      this.search_credit_payment = false;
      this.search_about_test_bullet = false;
      this.search_test_bullet_required = false;
      this.search_about_return = false;
      this.search_about_exchange = false;
      // 以下商品のみ検索項目      
      this.search_state = 0;
      this.search_type = 0;
      this.search_brand = [];
      this.search_price_from = null;
      this.search_price_to = null;
      this.search_send_price_from = null;
      this.search_send_price_to = null;
      this.search_size = 0;
      this.search_function = 0;
      this.search_color = 0;
      this.search_year = 0;
      return false;
    },
    sp_open() {
      if ( this.is_sp_open ) {
        this.sp_open_text = '＋詳細検索';
      } else {
        this.sp_open_text = '－詳細検索';
      }
      this.is_sp_open = !this.is_sp_open;
    },
		allClickCallbackProduct: function (pageNum) {
      this.all_currentPage_product = Number(pageNum);
			this.$nextTick(() => {
				window.scrollTo({
					top: 0,
				});
			});
    },
		allClickCallbackSeller: function (pageNum) {
      this.all_currentPage_seller = Number(pageNum);
			this.$nextTick(() => {
				window.scrollTo({
					top: 0,
				});
			});
    },
    variable_to_param() {
      // console.log(this.search_brand);
      let redirect_url = '?main_search_type='+String(this.main_search_type);
      // キーワード
      if ( this.search_word ) {
        redirect_url+='&search_word='+this.search_word;
      }
      // 並び替え
      redirect_url+='&search_sort_type='+String(this.search_sort_type);
      // 都道府県
      if ( this.search_region && String(this.search_region) != "" ) {
        redirect_url+='&search_region='+this.search_region;//this.get_hash_value(this.search_region_arr, this.search_region);
      }
      // 市区町村
      if ( this.search_city && String(this.search_city) != "" ) {
        redirect_url+='&search_city='+this.search_city;//this.get_hash_value(this.search_city_arr, this.search_city);
      }
      // その他条件
      if ( this.search_about_areas_sell ) {
        redirect_url+='&search_about_areas_sell=1';
      }
      if ( this.search_whether_pay_installments ) {
        redirect_url+='&search_whether_pay_installments=1';
      }
      if ( this.search_credit_payment ) {
        redirect_url+='&search_credit_payment=1';
      }
      if ( this.search_about_test_bullet ) {
        redirect_url+='&search_about_test_bullet=1';
      }
      if ( this.search_test_bullet_required ) {
        redirect_url+='&search_test_bullet_required=1';
      }
      if ( this.search_about_return ) {
        redirect_url+='&search_about_return=1';
      }
      if ( this.search_about_exchange ) {
        redirect_url+='&search_about_exchange=1';
      }
      // 商品条件
      if (String(this.main_search_type)=="1") {
        // 状態
        if ( String(this.search_state) != "0" ) {
          redirect_url+='&search_state='+String(this.search_state);
        }
        // タイプ
        if ( String(this.search_type) != "0" ) {
          redirect_url+='&search_type='+String(this.search_type);
        }
        // ブランド
        if ( this.search_brand.length > 0 ) {
          redirect_url+='&search_brand='+String(this.search_brand.join(','));
        }
        // 価格
        if ( this.search_price_from != null && this.search_price_from != "" ) {
          redirect_url+='&search_price_from='+String(this.search_price_from);
        }
        if ( this.search_price_to != null && this.search_price_to != "" ) {
          redirect_url+='&search_price_to='+String(this.search_price_to);
        }
        // 送料
        if ( this.search_send_price_from != null && this.search_send_price_from != "" ) {
          redirect_url+='&search_send_price_from='+String(this.search_send_price_from);
        }
        if ( this.search_send_price_to != null && this.search_send_price_to != "" ) {
          redirect_url+='&search_send_price_to='+String(this.search_send_price_to);
        }
        // サイズ
        if ( String(this.search_size) != "0" ) {
          redirect_url+='&search_size='+String(this.search_size);
        }
        // 機能
        if ( String(this.search_function) != "0" ) {
          redirect_url+='&search_function='+String(this.search_function);
        }
        // カラー
        if ( String(this.search_color) != "0" ) {
          redirect_url+='&search_color='+String(this.search_color);
        }
        // 年代
        if ( String(this.search_year) != "0" ) {
          redirect_url+='&search_year='+String(this.search_year);
        }
      }
      // if ( url_only ) {
      //   return redirect_url;
      // }
      if ( redirect_url != '' ) {
        // location.search = redirect_url;
        this.$router.push({path: '/search', query: this.para_get(redirect_url)});
        this.param_to_variable();
      }
      return false;
    },
    param_to_variable() {
      // 検索タイプ
      if ( this.$route.query.main_search_type ) {
        this.main_search_type = this.$route.query.main_search_type;
      }
      // キーワード
      if ( this.$route.query.search_word ) {
        this.search_word = this.$route.query.search_word;
      }
      // 並び替え
      if ( this.$route.query.search_sort_type ) {
        this.search_sort_type = this.$route.query.search_sort_type;
      }
      // 都道府県
      if ( this.$route.query.search_region ) {
        this.search_region = this.$route.query.search_region;
      }
      // 市区町村
      if ( this.$route.query.search_city ) {
        this.search_city = this.$route.query.search_city;
      }
      // その他条件
      if ( this.$route.query.search_about_areas_sell && String(this.$route.query.search_about_areas_sell) == "1" ) {
        this.search_about_areas_sell = true;
      }
      if ( this.$route.query.search_whether_pay_installments && String(this.$route.query.search_whether_pay_installments) == "1" ) {
        this.search_whether_pay_installments = true;
      }
      if ( this.$route.query.search_about_test_bullet && String(this.$route.query.search_about_test_bullet) == "1" ) {
        this.search_about_test_bullet = true;
      }
      if ( this.$route.query.search_test_bullet_required && String(this.$route.query.search_test_bullet_required) == "1" ) {
        this.search_test_bullet_required = true;
      }
      if ( this.$route.query.search_about_return && String(this.$route.query.search_about_return) == "1" ) {
        this.search_about_return = true;
      }
      if ( this.$route.query.search_about_exchange && String(this.$route.query.search_about_exchange) == "1" ) {
        this.search_about_exchange = true;
      }
      // 商品条件
      if (String(this.main_search_type)=="1") {
        // 状態
        if ( this.$route.query.search_state && String(this.$route.query.search_state) != "0" ) {
          this.search_state = this.$route.query.search_state
        }
        // タイプ
        if ( this.$route.query.search_type && String(this.$route.query.search_type) != "0" ) {
          this.search_type = this.$route.query.search_type
        }
        // ブランド
        if ( this.$route.query.search_brand && String(this.$route.query.search_brand) != "" ) {
          this.search_brand = this.$route.query.search_brand.split(',')
        }
        // 価格
        if ( this.$route.query.search_price_from ) {
          this.search_price_from = this.$route.query.search_price_from
        }
        if ( this.$route.query.search_price_to ) {
          this.search_price_to = this.$route.query.search_price_to
        }
        // 送料
        if ( this.$route.query.search_send_price_from ) {
          this.search_send_price_from = this.$route.query.search_send_price_from
        }
        if ( this.$route.query.search_send_price_to ) {
          this.search_send_price_to = this.$route.query.search_send_price_to
        }
        // サイズ
        if ( this.$route.query.search_size && String(this.$route.query.search_size) != "0" ) {
          this.search_size = this.$route.query.search_size
        }
        // 機能
        if ( this.$route.query.search_function && String(this.$route.query.search_function) != "0" ) {
          this.search_function = this.$route.query.search_function
        }
        // カラー
        if ( this.$route.query.search_color && String(this.$route.query.search_color) != "0" ) {
          this.search_color = this.$route.query.search_color
        }
        // 年代
        if ( this.$route.query.search_year && String(this.$route.query.search_year) != "0" ) {
          this.search_year = this.$route.query.search_year
        }
      }
      let title_tag = "一覧 - ピアチュウ";
      if (String(this.main_search_type)=="1") {
        title_tag = "中古ピアノ" + title_tag;
      } else if (String(this.main_search_type)=="2") {
        title_tag = "中古ピアノ販売店" + title_tag;
      }
      if ( this.search_region && String(this.search_region) != "" ) {
        title_tag = String(this.search_region) + "　" + title_tag;
      } else {
        title_tag = "全国の" + title_tag;
      }
      document.title = title_tag;
      this.search_exec();
    },
	  jumpDetail: function(id){
        this.$router.push({path: '/product/'+String(id)});
	  },
    jumpSellerDetail: function(id){
        this.$router.push({path: '/seller/'+String(id)});
	  },
    para_get: function(str){
      var url_search = str.substr(1).split('&');
      var para = [];
      var key = null;
      for(var i = 0 ; i < url_search.length ; i++)
      {
        key = url_search[i].split("=");
        para[key[0]] = key[1];
      }
      return (para);
    },
    set_address_info: function() {
      this.search_region_arr = [];
      this.search_region_arr.push({
        "no":"","name":"未選択",
      });
      for (let key in this.address_info[String(this.main_search_type)]) {
        this.search_region_arr.push({
          "no":key,"name":key+"("+this.address_info[String(this.main_search_type)][key]['total_count']+")", //this.pref_strring_to_code(key)
        });
      }
    },
    set_city: function(city) {
      this.search_city_arr = [];
      this.search_city_arr.push({
        "no":"","name":"未選択",
      });
      if (this.search_region!='') {
        console.log(this.address_info);
        console.log(String(this.main_search_type));
        console.log(String(this.search_region));
        for (let key in this.address_info[String(this.main_search_type)][this.search_region]['city']) {
          this.search_city_arr.push({
            "no":key,"name":key+"("+this.address_info[String(this.main_search_type)][this.search_region]['city'][key]+")",
          });
        }
      } else {
        this.search_city = '';
      }
    },
  },
  computed: {
    allProducts: function() {
			return this.all_products;
		},
    allSellers: function() {
			return this.all_sellers;
		},
		allGetProducts: function() {
			let current = this.all_currentPage_product * this.all_parPage_product;
			let start = current - this.all_parPage_product;
			return this.all_products.slice(start, current);
		},
		allGetPageCountProduct: function() {
			return Math.ceil(this.all_products.length / this.all_parPage_product);
		},
		allGetSellers: function() {
			let current = this.all_currentPage_seller * this.all_parPage_seller;
			let start = current - this.all_parPage_seller;
			return this.all_sellers.slice(start, current);
		},
		allGetPageCountSeller: function() {
			return Math.ceil(this.all_sellers.length / this.all_parPage_seller);
		},
  },
  created() {
    noretryAuthAxios.get('/api/address_info').then(res => {
      this.address_info = res.data;
      if ( this.$route.query.main_search_type ) {
        this.main_search_type = this.$route.query.main_search_type;
      }
      this.set_address_info();
      window.addEventListener('resize',this.handleResize);
      this.handleResize();
      if ( location.search != "" ) {
        this.param_to_variable();
      }
    }).catch(error => {
      console.log('error発生');
      console.log(error);
      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
        });
      });
    });
  },
  mounted() {
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  }

}
</script>

<style scoped>

/* PC */
.sp_menu {
  display: none;
}

@media screen and (max-width: 764px) {
  /* スマホ */
  .sp_menu {
    display: block;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Search.vue